import { render, staticRenderFns } from "./ScrollMessage.vue?vue&type=template&id=59c0ad3e&scoped=true&"
import script from "./ScrollMessage.vue?vue&type=script&lang=js&"
export * from "./ScrollMessage.vue?vue&type=script&lang=js&"
import style0 from "./ScrollMessage.vue?vue&type=style&index=0&id=59c0ad3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c0ad3e",
  null
  
)

export default component.exports